import Utils from '../../../utils/util';

function layoutSplitY(layerChildrenCoordinate: CubePaintCoordinate[], boxArea: PaintCoordinate): CabinetColPaintCoordinateItem[] {
    let result: CabinetColPaintCoordinateItem[] = [];
    let baseLineTop: number = Utils.math(boxArea.top, boxArea.height, '+');

    for (let i = 0; i < layerChildrenCoordinate.length; i++) {
        let prev: CubePaintCoordinate = layerChildrenCoordinate[i - 1];
        let now: CubePaintCoordinate = layerChildrenCoordinate[i];
        let bottomLine: number = Utils.math(now.top, now.height, '+');
        let halfNow: number = Utils.math(now.height, 2, '/');
        let next: CubePaintCoordinate = layerChildrenCoordinate[i + 1];
        let bottomSpaceWidth: number = 0;
        let topSpaceWidth: number = 0;

        if (i === 0) {
            bottomSpaceWidth = Utils.math(baseLineTop, bottomLine, '-');
        }
        else {
            bottomSpaceWidth = Utils.math(prev.top, bottomLine, '-');
            bottomSpaceWidth = Utils.math(bottomSpaceWidth, 2, '/');
        }

        if (i === layerChildrenCoordinate.length - 1) {
            topSpaceWidth = Utils.math(now.top, boxArea.top, '-');
        }
        else {
            let nextBottomLine: number = Utils.math(next.top, next.height, '+');

            topSpaceWidth = Utils.math(now.top, nextBottomLine, '-');
            topSpaceWidth = Utils.math(topSpaceWidth, 2, '/');
        }

        if (topSpaceWidth < 0) {
            topSpaceWidth = 0;
        }

        let bottomArea: CabinetColPaintCoordinateItem = {
            id: now.id,
            left: now.left,
            top: Utils.math(now.top, halfNow, '+'),
            width: now.width,
            height: Utils.math(halfNow, bottomSpaceWidth, '+'),
            dir: 'bottom'
        };
        let topArea: CabinetColPaintCoordinateItem = {
            id: now.id,
            left: now.left,
            top: Utils.math(now.top, topSpaceWidth, '-'),
            width: now.width,
            height: Utils.math(halfNow, topSpaceWidth, '+'),
            dir: 'top'
        };

        result.push(bottomArea);
        result.push(topArea);
    }

    return result;
}

export {
    layoutSplitY
};
